module.exports = "<div register-custom-form-control=\"\">\n  <div class=\"form-value checkbox\"  ng-repeat=\"item in choices\" >\n    <label>\n      <input type=\"checkbox\" value=\"item[0]\" ng-model=\"selected_items[item[0]]\" ng-change=\"onChange(item[0], selected_items[item[0]])\"/>\n      {{ item[1] }}\n    </label>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/multiselect.html
// module id = 293
// module chunks = 0